import { FetchError } from '../errors/FetchError'
import { fetchWithAuthorization } from './fetch'

export const getAllvisitor = async (page, limit = 10, params) => {
  const { search, property, type, condominium } = params

  try {
    let url = `/visitor?visitor=${type}&page=${page}&limit=${limit}`

    if (property) url += `&property=${property}`

    if (condominium) url += `&condominium=${condominium}`

    if (search) url += `&search=${encodeURIComponent(search)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getAllvisitor')
  }
}

export const getAllVisitorRegistered = async (page, limit = 10, params) => {
  const {
    search_visitor,
    search_property,
    condominium,
    departure_time,
    entry_time_at,
    departure_time_at,
    entry_time_date,
    departure_time_date
  } = params

  try {
    let url = `/registered/visit?page=${page}&limit=${limit}`

    if (condominium) url += `&condominium=${condominium}`
    if (departure_time !== 0) url += `&deperture_time=${departure_time}`
    if (entry_time_at) url += `&entry_time_at=${entry_time_at}`
    if (entry_time_date) url += `&entry_time_date=${entry_time_date}`
    if (departure_time_at) url += `&departure_time_at=${departure_time_at}`
    if (departure_time_date) url += `&departure_time_date=${departure_time_date}`
    if (search_property) url += `&search_property=${encodeURIComponent(search_property)}`
    if (search_visitor) url += `&search_visitor=${encodeURIComponent(search_visitor)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getAllVisitorRegistered')
  }
}

export const createVisitor = async (obj) => {
  try {
    const data = await fetchWithAuthorization('/visitor', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create visitor failed')
  }
}

export const visitorCheckIn = async (obj) => {
  try {
    const data = await fetchWithAuthorization('/registered/visit', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create check in visitor failed')
  }
}

export const visitorCheckOut = async (id) => {
  try {
    const data = await fetchWithAuthorization(`/registered/visit/${id}`, null, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create check out visitor failed')
  }
}
